import { NumberFormatValues } from 'react-number-format';

export const isNumberAllowed = (values: NumberFormatValues) => {
  const { floatValue } = values;
  return (floatValue || 0) < 1000000;
};
